/* Иконки макета — линейные, 24×24, `stroke="currentColor"`.

   Скопированы из `restyle/Кабинет пациента - aventrae.html` без изменения путей:
   толщина и скругления там подобраны под размер, и «поправить» их значило бы
   разойтись с макетом на глаз.

   Размер задаётся параметром, а не свойством в CSS: у одной и той же иконки в
   макете разные размеры в меню (19) и в кнопках (16-17). */

type P = { size?: number };

const base = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
};

export function CalendarIcon({ size = 19 }: P) {
    return (
        <svg width={size} height={size} strokeWidth={1.7} {...base}>
            <path d="M4 6h16v15H4zM4 10h16M8 3v4M16 3v4" />
        </svg>
    );
}

/** Капля — знак плана ухода. */
export function CareIcon({ size = 19 }: P) {
    return (
        <svg width={size} height={size} strokeWidth={1.7} {...base}>
            <path d="M12 20s7-4.2 7-9.4A4.6 4.6 0 0 0 12 7a4.6 4.6 0 0 0-7 3.6C5 15.8 12 20 12 20z" />
        </svg>
    );
}

/** Закладка — знак избранных врачей. */
export function BookmarkIcon({ size = 19 }: P) {
    return (
        <svg width={size} height={size} strokeWidth={1.7} {...base}>
            <path d="M7 4h10v16l-5-4-5 4z" />
        </svg>
    );
}

export function PersonIcon({ size = 19 }: P) {
    return (
        <svg width={size} height={size} strokeWidth={1.7} {...base}>
            <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 20a7 7 0 0 1 14 0" />
        </svg>
    );
}

export function ExitIcon({ size = 17 }: P) {
    return (
        <svg width={size} height={size} strokeWidth={1.8} {...base}>
            <path d="M15 5.5V4.5A1.5 1.5 0 0 0 13.5 3h-8A1.5 1.5 0 0 0 4 4.5v15A1.5 1.5 0 0 0 5.5 21h8a1.5 1.5 0 0 0 1.5-1.5v-1M10 12h10M17 8.5 20.5 12 17 15.5" />
        </svg>
    );
}

export function PlusIcon({ size = 16 }: P) {
    return (
        <svg width={size} height={size} strokeWidth={2.1} {...base}>
            <path d="M12 5v14M5 12h14" />
        </svg>
    );
}

export function SearchIcon({ size = 16 }: P) {
    return (
        <svg width={size} height={size} strokeWidth={1.8} {...base}>
            <circle cx="11" cy="11" r="7" />
            <path d="M20 20l-3.5-3.5" />
        </svg>
    );
}

/** Замок — у поля, которое читается, но не правится (телефон). */
export function LockIcon({ size = 15 }: P) {
    return (
        <svg width={size} height={size} strokeWidth={1.8} {...base}>
            <path d="M7 10V8a5 5 0 0 1 10 0v2M6 10h12v10H6z" />
        </svg>
    );
}
